{
    "SignInWith_Title": "Aanmelden met",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Meld u aan met andere opties"
}